export const DEFAULT_MESSAGE_GROUPS_BY_SEGMENT = {
    b2c: [
        'SELF_SERVICE_ACCOUNT',
        'SELF_SERVICE_API_ERROR',
        'SELF_SERVICE_COMMON',
        'SELF_SERVICE_COMPONENT',
        'SELF_SERVICE_CONSENTS',
        'SELF_SERVICE_CONTRACT_TERMINATION',
        'SELF_SERVICE_CUSTOMER',
        'SELF_SERVICE_DASHBOARD',
        'SELF_SERVICE_DOCUMENTS',
        'SELF_SERVICE_FIX_DIAGNOSTICS',
        'SELF_SERVICE_INSTALLMENTS',
        'SELF_SERVICE_INVOICES',
        'SELF_SERVICE_MANDATES',
        'SELF_SERVICE_MISC',
        'SELF_SERVICE_ORDER_HISTORY',
        'SELF_SERVICE_OVERDUE_PAYMENT',
        'SELF_SERVICE_PAYMENT',
        'SELF_SERVICE_PERSONAL_OFFERS',
        'SELF_SERVICE_RATE_PLAN_CHANGE',
        'SELF_SERVICE_SERVICES',
        'SELF_SERVICE_SETTINGS',
        'SELF_SERVICE_SIM_CARD_ACTIONS',
        'SELF_SERVICE_SMART_WIFI',
        'SELF_SERVICE_B2C',
        'SSO',
        'SSO_B2C',
        'SEARCH',
        'SEARCH_B2C_B2B',
        'ESHOP',
        'ESHOP_CHECKOUT',
        'ESHOP_ORDER_CART',
        'ESHOP_CATEGORY_PAGE',
        'ESHOP_PRODUCT_PAGE',
        'ESHOP_COMPARISON',
        'ESHOP_UPSELL',
        'ESHOP_PLAN',
        'ESHOP_LOGIN',
        'ESHOP_B2C',
        'NAVBAR',
        'NAVBAR_B2C_B2B',
        'FOOTER_B2C_B2B',
        'HELP',
        'HELP_B2C',
        'TARIFF',
        'TARIFF_B2C',
        'ROUTE_CABLES',
        'ROUTE_CABLES_B2C',
        'LEAD',
        'LEAD_B2C',
        'PLANS',
        'TV_ORDERING',
        'TG_CHECK',
        'PUSH_OFFER',
        'HOSTEX_LOGIN',
        'WIFI_SETTINGS',
        'DST',
        'RETAILS_MAP',
        'GO3_LOGIN',
        'FAQ',
        'MODEM_ORDERING',
        'CONTENT',
        'BLOG',
        'COMMON',
        'COMMON_B2C',
        'ORDER_CART',
    ],
    b2b: [
        'SELF_SERVICE_ACCOUNT',
        'SELF_SERVICE_API_ERROR',
        'SELF_SERVICE_COMMON',
        'SELF_SERVICE_COMPONENT',
        'SELF_SERVICE_CONSENTS',
        'SELF_SERVICE_CONTRACT_TERMINATION',
        'SELF_SERVICE_CUSTOMER',
        'SELF_SERVICE_DASHBOARD',
        'SELF_SERVICE_DOCUMENTS',
        'SELF_SERVICE_INSTALLMENTS',
        'SELF_SERVICE_INVOICES',
        'SELF_SERVICE_MANDATES',
        'SELF_SERVICE_MISC',
        'SELF_SERVICE_ORDER_HISTORY',
        'SELF_SERVICE_OVERDUE_PAYMENT',
        'SELF_SERVICE_PAYMENT',
        'SELF_SERVICE_PERSONAL_OFFERS',
        'SELF_SERVICE_RATE_PLAN_CHANGE',
        'SELF_SERVICE_SERVICES',
        'SELF_SERVICE_SETTINGS',
        'SELF_SERVICE_SIM_CARD_ACTIONS',
        'SELF_SERVICE_SMART_WIFI',
        'SELF_SERVICE_B2B',
        'SSO',
        'SSO_B2B',
        'SEARCH',
        'SEARCH_B2C_B2B',
        'ESHOP',
        'ESHOP_CHECKOUT',
        'ESHOP_ORDER_CART',
        'ESHOP_CATEGORY_PAGE',
        'ESHOP_PRODUCT_PAGE',
        'ESHOP_COMPARISON',
        'ESHOP_UPSELL',
        'ESHOP_PLAN',
        'ESHOP_LOGIN',
        'ESHOP_B2B',
        'NAVBAR',
        'NAVBAR_B2C_B2B',
        'FOOTER_B2C_B2B',
        'HELP',
        'HELP_B2B',
        'TARIFF',
        'TARIFF_B2B',
        'ROUTE_CABLES',
        'ROUTE_CABLES_B2B',
        'LEAD',
        'LEAD_B2B',
        'PLANS',
        'TG_CHECK',
        'PUSH_OFFER',
        'HOSTEX_LOGIN',
        'WIFI_SETTINGS',
        'DST',
        'RETAILS_MAP',
        'FAQ',
        'MODEM_ORDERING',
        'CONTENT',
        'COMMON',
        'COMMON_B2B',
        'ORDER_CART',
    ],
    fix: [
        'SELF_SERVICE_ACCOUNT',
        'SELF_SERVICE_API_ERROR',
        'SELF_SERVICE_COMMON',
        'SELF_SERVICE_COMPONENT',
        'SELF_SERVICE_CONSENTS',
        'SELF_SERVICE_CONTRACT_TERMINATION',
        'SELF_SERVICE_CUSTOMER',
        'SELF_SERVICE_DASHBOARD',
        'SELF_SERVICE_DOCUMENTS',
        'SELF_SERVICE_INSTALLMENTS',
        'SELF_SERVICE_INVOICES',
        'SELF_SERVICE_MANDATES',
        'SELF_SERVICE_MISC',
        'SELF_SERVICE_ORDER_HISTORY',
        'SELF_SERVICE_OVERDUE_PAYMENT',
        'SELF_SERVICE_PAYMENT',
        'SELF_SERVICE_PERSONAL_OFFERS',
        'SELF_SERVICE_RATE_PLAN_CHANGE',
        'SELF_SERVICE_SERVICES',
        'SELF_SERVICE_SETTINGS',
        'SELF_SERVICE_SIM_CARD_ACTIONS',
        'SELF_SERVICE_SMART_WIFI',
        'SELF_SERVICE_B2B',
        'SEARCH',
        'SEARCH_B2C_B2B',
        'NAVBAR',
        'NAVBAR_B2C_B2B',
        'FOOTER_B2C_B2B',
        'LEAD',
        'LEAD_B2B',
        'COMMON',
        'COMMON_B2B',
    ],
    extra: [
        'SEARCH',
        'SEARCH_B2C_B2B',
        'NAVBAR',
        'NAVBAR_B2C_B2B',
        'FOOTER_B2C_B2B',
        'LEAD',
        'LEAD_B2C',
        'COMMON',
        'COMMON_B2C',
    ],
    english: [
        'SSO',
        'SSO_ENGLISH',
        'SEARCH',
        'SEARCH_ENGLISH',
        'NAVBAR',
        'NAVBAR_ENGLISH',
        'FOOTER_ENGLISH',
        'COMMON',
        'COMMON_ENGLISH',
    ],
    russian: ['SEARCH', 'SEARCH_RUSSIAN', 'NAVBAR', 'NAVBAR_RUSSIAN', 'FOOTER_RUSSIAN', 'COMMON', 'COMMON_RUSSIAN'],
};
